import { Navigate } from 'react-router-dom';
import React, { PropsWithChildren, useEffect, useState } from 'react';

import Footer from '../Footer';
import Header from '../Header';
import {
  HOME_ROUTE,
  LOGIN_ROUTE,
  AUTHORIZED_ROUTE,
} from '../../utils/constants';
import { checkUserStatus } from '../../services/Authentication';
import { RootState } from '../../store/appStore';
import { addUser, removeUser } from '../../store/slices/userSlice';
import ErrorBoundary from '../utils/ErrorBoundary';
import PageLoader from '../utils/PageLoader';
import OfflinePage from '../Body/OfflinePage';
import { useAppDispatch, useAppSelector } from '../../utils/hooks';

interface TemplateWrapperProps {
  routeUrl: string;
}

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [offline, setOffline] = useState(false);
  useEffect(() => {
    if (!navigator.onLine) setOffline(true);
  }, []);
  return (
    <ErrorBoundary fallback={<PageLoader />}>
      <Header />
      {offline ? <OfflinePage /> : children}
      <Footer />
    </ErrorBoundary>
  );
};

const TemplateWrapper = ({
  routeUrl,
  children,
}: PropsWithChildren<TemplateWrapperProps>) => {
  const userToken = useAppSelector((store: RootState) => store.user.userToken);
  const dispatch = useAppDispatch();
  const getUserStatus = async () => {
    try {
      const userData = await checkUserStatus();
      dispatch(addUser(userData));
    } catch (err) {
      dispatch(removeUser());
    }
  };
  useEffect(() => {
    getUserStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routeUrl]);
  if (AUTHORIZED_ROUTE.includes(routeUrl)) {
    return <Layout>{children}</Layout>;
  } else if (routeUrl === LOGIN_ROUTE) {
    return userToken ? (
      <Navigate to={HOME_ROUTE} replace />
    ) : (
      <Layout>{children}</Layout>
    );
  }
  return userToken ? (
    <Layout>{children}</Layout>
  ) : (
    <Navigate to={LOGIN_ROUTE} replace />
  );
};

export default TemplateWrapper;
